<template>
  <el-row class="editor-top-inside" :class="themeInfoClassName">
    <el-col :span="12" class="left">
      <div class="left-inside">
        <div class="back" @click="handleBack">
          <el-tooltip class="item" effect="dark" content="返回上一页" placement="top-start">
            <span class="back-inside">
              <i class="el-icon-back" />
            </span>
          </el-tooltip>
        </div>
        <div class="file_name">
          <el-tooltip class="item" effect="dark" :content="(getFileInfo.name)" placement="bottom">
            <span>{{getFileInfo.name}}</span>
          </el-tooltip>
        </div>
        <div class="WordNum">
          字数：<span>{{getFileInfo.sourceWordNum}}</span>
        </div>
      </div>
    </el-col>
    <el-col :span="12" class="right">
      <div class="right-inside" :class="getUrlTypeClass">
        <!-- 临时术语表 -->
        <template>
          <div class="term-btn" @click="handleViewTermTable">
            <i class="term-icon"></i>
            <span class="term-text">术语表</span>
          </div>
          <div class="line" />
        </template>

        <!--外网检索设置-->
        <template>
          <el-popover trigger="hover" placement="bottom" class="setting-wrap2"
                      popper-class="setting-wrap">
            <div class="setting-inside">
              <el-radio-group v-model="radio" @change="handleSearchChange">
                <el-row class="setting-radio">
                  <!-- <el-col :span="24">
                    <el-radio :label="1">百度</el-radio>
                  </el-col>
                  <el-col :span="24">
                    <el-radio :label="2">Google</el-radio>
                  </el-col>
                  <el-col :span="24">
                    <el-radio :label="3">搜狗</el-radio>
                  </el-col>
                  <el-col :span="24">
                    <el-radio :label="4">Bing</el-radio>
                  </el-col> -->
                  <el-col v-for="engine in SEARCH_ENGINE" :key="engine.icon" :span="24">
                    <el-radio :label="engine.value">{{ engine.name }}</el-radio>
                  </el-col>
                </el-row>
              </el-radio-group>
            </div>

            <el-button slot="reference">
              <div class="setting">设置</div>
            </el-button>
          </el-popover>
          <div class="line" />
        </template>
        <template v-if="getUrlInfo.type!=='school'">
          <el-popover trigger="hover" placement="bottom-start" class="import-wrap2" v-model="visiblePopover"
                      popper-class="import-wrap">
            <div class="import-inside">
              <el-cascader-panel :options="importOption" v-model="cascaderVal"
                                 @change="handleClickDowload" :props="{ expandTrigger: 'hover' }">
              </el-cascader-panel>
            </div>
            <el-button slot="reference">
              <div class="import">导出</div>
            </el-button>
          </el-popover>
          <div class="line" />
        </template>
        <el-popover trigger="hover" placement="bottom" class="keyboard-shortcut-wrap2"
                    popper-class="keyboard-shortcut-wrap">
          <div class="keyboard-shortcut-inside">
            <KeyboardShortcut />
          </div>
          <el-button slot="reference">
            <div class="keyboard-shortcut">快捷键</div>
          </el-button>
        </el-popover>
        <div class="theme-model">
          <el-select v-model="value" placeholder="请选择" size="mini"
                     @change="()=>handleChange(value)">
            <el-option v-for="item in getTheneList" :key="item.value" :label="item.label"
                       :value="item.value" :disabled="item.disabled" />
          </el-select>
        </div>
        <div class="user-info">
          <div class="user-header">
            <el-badge is-dot class="item" :hidden="getShowhidden">
              <img :src="((getUserInfo.avatar) || url)" alt="用户头像" v-if="!IS_PRIVATE" />
              <img :src="url" alt="用户头像" v-else />
            </el-badge>
          </div>
          <div class="user-name">
            <el-dropdown trigger="hover">
              <span class="el-dropdown-link">
                {{getUserInfo.nickName||userInfo.nickName}}
                <i class="el-icon-caret-bottom el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown" class="header-drop">
                <el-dropdown-item @click.native="()=>handleUserCenter()">
                  {{$t('personCenterV2.personCenter')}}</el-dropdown-item>
                <el-dropdown-item @click.native="()=>handleOut()">{{$t('personCenterV2.logOut')}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

    </el-col>
    <Logout :shown="shown" @handleCancel="()=>handleCancel()" />
    <EditorDowload :shown="editorDowloadShown" @handleCancel="()=>handleCancel()" />
    <SubmitDialog :submitVisible="submitVisible" @jumpSentence="jumpSentence"
                  @ignoreSubmit="ignoreSubmit" @beforeClose="beforeClose" />
    <TargetiscontentDIalog :submitVisible="targetiscontentVisible"
                           @jumpSentence="handlerjumpSentence"
                           @beforeClose="closetargetoiscontent" />
    <TermTable :visible="termTableVisible" @handleClose="handleTermColse"
               @handleConfirm="handleTermConfirm" />

  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { apiRoot } from '@/services/ajax';
import Logout from '@/components/layer/logout';
import EditorDowload from '@/components/layer/editorDowload';
import KeyboardShortcut from './modules/keyboardShortcut'
import TermTable from './modules/term-table'
import SubmitDialog from './modules/submitDialog';
import TargetiscontentDIalog from "./modules/submitDialog/targetiscontentDIalog"
import { getTaskStatusAjax, getcountTargetSentIsNull } from "@/services/editorApi"
import { getDownloadAsyncResult, exportAsyncTransFile, downloadAsyncV2, exportTransFileTmx, exportTransFileXlf, getDownloadAsyncResultV2 } from '@/services/projectDetailsApi';
export default {
  name: "EditorTop",
  components: { Logout, EditorDowload, KeyboardShortcut, SubmitDialog, TermTable, TargetiscontentDIalog },
  // props: ['options'],
  data() {
    return {
      IS_PRIVATE: IS_PRIVATE,
      radio: 1,
      value: 'standard',
      cascaderVal: null,
      shown: false,
      editorDowloadShown: false,
      url: require("./assets/images/user.png"),
      submitVisible: false,
      taskStatus: {},
      termTableVisible: false,
      fileName: "",
      targetiscontentVisible: false,
      SEARCH_ENGINE: SEARCH_ENGINE,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      visiblePopover:false,
    }
  },
  computed: {
    ...mapGetters('editor', [
      'importOption',             // 导出选项
      'getUrlInfo',               // 路由信息
      'getThemeInfo',             // 主题信息
      'getTheneList',             // 主题选项
      'getUserInfo',              // 获取用户信息
      'getProjectInfo',           // 项目信息
      'getFileInfo',              // 获取文件信息
      'getTaskProgress',          // 获取任务进度
      'currentViewMode', //显示模式
    ]),
    ...mapGetters({
      gettersFileTaskInfo: 'editor/getFileTaskInfo'
    }),
    ...mapGetters('layout', [
      'getShowhidden',           // 是否隐藏头像
    ]),

    getUrlTypeClass() {
      const { type } = this.getUrlInfo
      if (type) {
        return `right-inside-${type}`;
      }
      return ''
    },

    /**
     * @desc  获取主题动态类名
     * @return {string} className
     */
    themeInfoClassName() {
      let className = `editor-top-inside-${this.getThemeInfo}`
      return className
    },

    /**
     * @desc 获取任务信息
     * @return {object} result
     */
    getFileTaskInfo() {
      let result = {}
      const { type } = this.getUrlInfo
      if (type === 'project') {
        result = this.getFileInfo
      }
      return result;
    },
  },
  mounted() {
    this.initThemeInfo();
    this.initSearchInfo();
    this.$store.dispatch("layout/showhidden");
    this.fileName = sessionStorage.getItem("fileName");
    const routeName = this.$route.name

    // this.getTaskStatus()

    // this.$nextTick(() => {
    //   const root = document.documentElement
    //   console.log(root, 'root');
    // })

  },

  methods: {

    // 查看术语表
    handleViewTermTable() {
      this.termTableVisible = true
    },
    //关闭术语表
    handleTermColse() {
      this.termTableVisible = false;
    },
    //保存至术语
    handleTermConfirm() {
      this.termTableVisible = false;
    },
    //获取任务状态
    // getTaskStatus() {
    //   setTimeout(async () => {
    //     let UrlInfo = this.getUrlInfo
    //     const { result, success } = await getTaskStatusAjax({ fileId: UrlInfo.fileId });
    //     if (success) {
    //       // transStatus  翻译状态  reviewStatus  审校状态
    //       this.fileTaskStatus = { ...result };
    //       console.log(this.fileTaskStatus)
    //     }
    //   }, 500)
    // },
    //获取主题
    initThemeInfo() {
      let theme = localStorage.getItem("theme") || 'standard';
      this.value = theme;
      if (this.$route.name !== 'newEditor' && theme === 'eye-protection') {
        this.value = 'standard';
      }
      this.$store.dispatch('editor/setThemeInfo', theme);
    },

    //获取搜索信息
    initSearchInfo() {
      window.setTimeout(() => {
        const { mtSearchId } = this.getProjectInfo
        this.radio = mtSearchId || 1;
        localStorage.setItem("search", parseInt(this.radio))
        this.$store.dispatch('editor/setSearchInfo', parseInt(this.radio));
      }, 1000)
    },

    //改变主题
    handleChange(value) {
      localStorage.setItem('theme', value);
      this.value = value;
      this.$store.dispatch('editor/setThemeInfo', value);
    },

    //改变搜索
    handleSearchChange(value) {
      localStorage.setItem('search', parseInt(value));
      this.radio = parseInt(value);
      this.$store.dispatch('editor/setSearchInfo', parseInt(value));
    },

    //获取任务类型
    getType(item) {
      let taskType = (item.taskType);
      switch (taskType) {
        case 1:
          return '翻译任务';
        case 2:
          return '审校任务';
        case 3:
          return '终审任务';
        default:
          return '翻译任务';
      }
    },

    //返回地址
    handleBack() {
      this.$router.go(-1)
      setTimeout(() => {
        localStorage.setItem('theme', 'standard')
        this.$store.dispatch('editor/setThemeInfo', 'standard')
      },500)
      // localStorage.removeItem("editorFontSize");
      // const { fromType, type, projectId, companyCode, fileId, studentId, userId, classId, routerType, routerData } = this.getUrlInfo
      // let timer = window.setTimeout(() => {
      //   clearTimeout(timer)
      //   timer = null
      //   this.value = 'standard';
      //   localStorage.setItem('theme', 'standard')
      //   this.$store.dispatch('editor/setThemeInfo', 'standard');
      // }, 500)
      // console.log(routerType)
      // if (routerType === 'translation') {
      //   this.$router.push({
      //     name: 'translation',
      //     query: {
      //       key: this.$Base64.encode(JSON.stringify({
      //         ...routerData
      //       }))
      //     }
      //   })
      // } else if (routerType === 'translationHistory') {
      //   this.$router.push({
      //     name: 'translationHistory'
      //   })
      // } else if (routerType === 'fileManage') {
      //   this.$router.push({
      //     name: 'fileManage',
      //     query: {
      //       key: this.$Base64.encode(JSON.stringify({
      //         ...routerData
      //       }))
      //     }
      //   })
      // }
    },

    //退出当前用户
    handleOut() {
      this.shown = true;
    },

    //文件导出
    handleEditorDowload() {
      this.editorDowloadShown = true;
    },

    //退出弹出取消
    handleCancel() {
      this.shown = false;
      this.editorDowloadShown = false;
    },

    //用户中心
    handleUserCenter() {
      this.$router.push({ path: '/home/personCenter' });
    },

    //点击下载导出文件
    handleClickDowload(value) {
      const self = this;
      let val = JSON.parse(JSON.stringify(value));
      if (val.length) {
        let lastVal = val[(val.length) - 1];
        switch (lastVal) {
          case 'source':
            self.handleDownload(6);
            break;
          case 'target-1':
            self.handleDownload(1);
            break;
          case 'source-target-2':
            self.handleDownload(2);
            break;
          case 'target-3':
            self.handleDownload(3);
            break;
          case 'source-target-4':
            self.handleDownload(4);
            break;
          case 'target-5':
            self.handleDownload(11);
            break;
          case 'source-target-6':
            self.handleDownload(12);
            break;
          case 'editorMark':
            self.handleDownload(5);
            break;
          case 'TMX':
            self.handleDownloadXLFTMX('TMX');
            break;
          case 'QA':
            self.handleQADownload(8);
            // console.log('QA报告');
            break;
          case 'XLF':
            self.handleDownloadXLFTMX('XLF');
            // console.log('XLF文档');
            break;
          default:
            console.log('查无此类型')
        }
        this.cascaderVal = []
        this.visiblePopover = false
      }
    },
    //XLF-TMX文件下载
    async handleDownloadXLFTMX(type) {
      let params = {};
      const { type: urlType } = this.getUrlInfo
      let fileId = null;
      if (urlType === 'project') {
        fileId = this.getFileTaskInfo.id
      } else if (urlType === 'task' || urlType === 'school') {
        fileId = this.getFileTaskInfo.fileId
      }
      Reflect.set(params, 'id', fileId);
      let resp = null;
      if (type === 'XLF') {
        resp = await exportTransFileXlf(params);
      } else if (type === 'TMX') {
        resp = await exportTransFileTmx(params);
      }
      if (resp.status === 200 && resp.success) {
        let results = resp.result;
        window.open(results);
      }
    },

    //下载前获取进度
    async handleDownload(type) {
      const self = this;
      this.$store.dispatch("editor/setloading", true);
      let params = Object();
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      let fileId = 0;
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);
      } else if (((urlInfo.type) === 'task') || ((urlInfo.type) === 'school')) {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      Reflect.set(params, 'fileId', (fileId));
      Reflect.set(params, 'type', type);
      let resp = await exportAsyncTransFile(params);
      if ((resp.status) === 200 && (resp.success)) {
        let results = (resp.result);
        if (parseInt(results.percent) === 100) {
          //直接下载
          this.handleDownloadFile((results.fileName), (results.downloadUrl))
        } else {
          //轮训获取
          this.handleDownloadAsyncResult((results.taskKey));
        }
      }
    },
    //qa下载
    async handleQADownload(type) {
      const self = this;
      // this.loading = true;
      this.$store.dispatch("editor/setloading", true);
      let params = Object();
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      let fileId = 0;
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);
      } else if (((urlInfo.type) === 'task') || ((urlInfo.type) === 'school')) {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      Reflect.set(params, 'fileId', (fileId));
      Reflect.set(params, 'type', type);
      let resp = await downloadAsyncV2(params);
      if ((resp.status) === 200 && (resp.success)) {
        let results = (resp.result);
        if (parseInt(results.percent) === 100) {
          //直接下载
          this.handleDownloadFile((results.downloadUrl), (results.downloadUrl))
        } else {
          //轮训获取
          this.getDownloadQA((results.taskKey));
        }
      }
    },

    getDownloadQA(key) {
      let setItem = setInterval(async () => {
        let resp = await getDownloadAsyncResultV2({ taskKey: key });
        if ((resp.status) === 200 && (resp.success)) {
          let results = (resp.result);
          if (parseInt(results.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.$store.dispatch("editor/cancelLoading");
            this.handleDownloadFile((results.downloadUrl), (results.downloadUrl))
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.$store.dispatch("editor/cancelLoading");
        }
      }, 2000);
    },

    //下载操作
    handleDownloadFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      this.$store.dispatch("editor/cancelLoading");
    },

    //异步下载操作
    handleDownloadAsyncResult(key) {
      let setItem = setInterval(async () => {
        let resp = await getDownloadAsyncResult({ taskKey: key });
        if ((resp.status) === 200 && (resp.success)) {
          let results = (resp.result);
          if (parseInt(results.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.$store.dispatch("editor/cancelLoading");
            this.handleDownloadFile((results.fileName), (results.downloadUrl))
          }
        } else {
          this.$store.dispatch("editor/cancelLoading");
          clearInterval(setItem);
          setItem = null;
        }
      }, 2000);
    },

    //提交任务
    async handleSubmitTask() {
      const self = this;
      let QAlist = self.$store.getters['editor/getQAList'] || {};
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      let params = {
        id: urlInfo.fileId,
        taskType: urlInfo.taskType,
        taskId: urlInfo.taskId,
      }
      if (urlInfo.type === "task") {
        const { result, success } = await getTaskStatusAjax({ fileId: urlInfo.fileId });
        if (success) {
          this.taskStatus = { ...result }
        }
      }

      const { result, success } = await getcountTargetSentIsNull(params);
      if (success) {
        if (QAlist.length >= 1) {
          if (QAlist.every(item => parseInt(item.isIgnore) === 1)) {
            this.submitjudge();
          } else {
            this.$message.closeAll();
            this.$message.warning("QA未解决应无法提交任务，请解决QA问题或忽略QA");
          }
        } else if (result.blankTargetSentIdList.length > 0) {
          this.targetiscontentVisible = true;
        } else {
          this.submitjudge();
        }
        this.$store.dispatch("editor/countTargetSentIsNull", params);
      }
    },
    //译文为空处理跳转
    handlerjumpSentence() {
      const targetIdList = this.$store.getters["editor/getcountTargetIsnullIdList"]
      let redborderDom = document.getElementsByClassName("redborder")[0];
      redborderDom.style.border = "1px solid red"
      this.targetiscontentVisible = false;
      redborderDom.scrollIntoView()
    },
    //关闭译文为空弹窗
    closetargetoiscontent() {
      this.targetiscontentVisible = false;
    },
    //判断校验
    submitjudge() {
      const { taskType, type } = this.getUrlInfo
      let fileId = null
      if (type === 'project') {
        let fileInfo = this.$store.getters['editor/getFileInfo'];
        fileId = fileInfo.id
      } else if (type === 'task' || type === 'school') {
        let fileTaskInfo = this.$store.getters['editor/getFileTaskInfo'];
        fileId = fileTaskInfo.fileId
      }
      let params = Object();
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'taskType', taskType);
      Reflect.set(params, 'id', fileId);
      //获取所有未锁定的句子
      let taskContentList = this.$store.getters['editor/getTaskContentList'].transSentRespVoList.filter(item => item.sameFileSentNo === 0 && item.sameProjectSentNo === 0);
      if (taskContentList.length === 0) {
        this.submitVisible = true;
        return
      }
      if (type === 'task') {
        Reflect.set(params, 'type', 1);
        switch (taskType) {
          case 1:
            if (taskContentList.every(item => item.status == 3)) {
              this.$store.dispatch('editor/submitTask', params).then((resp) => {
                if ((resp.status) === 200 && (resp.success)) {
                  location.reload();
                }
              })
            } else {
              this.submitVisible = true;
            }
            break;
          case 2:
            if (this.taskStatus.transStatus !== 0) {
              if (taskContentList.every(item => item.status == 4)) {
                this.$store.dispatch('editor/submitTask', params).then((resp) => {
                  if ((resp.status) === 200 && (resp.success)) {
                    location.reload();
                  }
                })
              } else {
                this.submitVisible = true;
              }
            } else {
              this.$message.closeAll();
              this.$message.error("请先完成翻译任务")
            }
            break;
          case 3:
            if (this.taskStatus.reviewStatus !== 0) {
              if (taskContentList.every(item => item.status == 5)) {
                this.$store.dispatch('editor/submitTask', params).then((resp) => {
                  if ((resp.status) === 200 && (resp.success)) {
                    location.reload();
                  }
                })
              } else {
                this.submitVisible = true;
              }
            } else {
              this.$message.closeAll();
              this.$message.error("请先完成审校任务")
            }
            break;
        }
      } else {
        // 作业提交
        Reflect.set(params, 'type', 2);
        Reflect.set(params, 'taskId', this.getUrlInfo.taskId)
        if (taskContentList.every(item => item.status == 3)) {
          this.$store.dispatch('editor/submitTask', params).then((resp) => {
            if ((resp.status) === 200 && (resp.success)) {
              location.reload();
            }
          })
        } else {
          this.submitVisible = true;
        }
      }
    },
    // 跳转到该句子
    jumpSentence() {
      this.submitVisible = false
      const dom = document.querySelectorAll('.translated-unsure')[0].parentNode.parentNode.parentNode;
      //跳转高亮
      const styleDom = dom.childNodes[2];
      styleDom.style.border = "1px solid red ";
      styleDom.classList.remove("noborder")
      dom.scrollIntoView()
    },
    // 忽略并提交
    async ignoreSubmit() {
      let params = Object();
      const { taskType, fileId } = this.getFileTaskInfo
      const { taskId, type } = this.getUrlInfo
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'taskType', taskType);
      Reflect.set(params, 'id', fileId);
      Reflect.set(params, 'ignoreSent', 1);
      if (type === 'school') {
        Reflect.set(params, 'taskId', taskId);
        Reflect.set(params, 'type', 2);
      } else {
        Reflect.set(params, 'type', 1);
      }
      const { success } = await this.$store.dispatch('editor/submitTask', params)
      if (success) {
        this.submitVisible = false
        location.reload();
      }
    },
    // 关闭前的回调
    beforeClose() {
      this.submitVisible = false
    },
  }
}
</script>
<style lang="less">
@import "./assets/global.less";
</style>

<style lang="less" scoped>
@import "./assets/style.less";
</style>